type NotifyTone = "error" | "success" | "warning" | "info"

function dispatchNotify(text: string, tone: NotifyTone): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("skrool:toast", { detail: { text, tone } }))
  }
}

/** Notifikasi toast global - memakai Ant Design agar axios tidak bergantung pada Element Plus. */
export function notifyError(text: string): void {
  dispatchNotify(text, "error")
}

export function notifySuccess(text: string): void {
  dispatchNotify(text, "success")
}

export function notifyWarning(text: string): void {
  dispatchNotify(text, "warning")
}

export function notifyInfo(text: string): void {
  dispatchNotify(text, "info")
}
